// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const Audit = t.struct({
    accounts: t.list(t.String, 'Accounts'),
    auditNumber: t.String,
    auditPlannedDate: t.maybe(t.Number),
    city: t.String,
    currency: KeyValuePair,
    daysRemaining: t.Number,
    dueDate: t.maybe(t.Number),
    isAuditPrepared: t.Bool,
    isSkipAuditAllowed: t.Bool,
    isSkippedAudit: t.Bool,
    leadAccount: t.String,
    leadAccountName: t.String,
    preparedDate: t.maybe(t.Number),
    rolling12MonthsCredit: t.Number,
    state: t.String,
    territory: t.String
}, {
    name: 'Audit',
    strict: true
});

export const getDefaultState = () => new Audit({
    accounts: [],
    auditNumber: '',
    auditPlannedDate: null,
    city: '',
    currency: getKeyValuePairDefaultState(),
    daysRemaining: 0,
    dueDate: null,
    isAuditPrepared: false,
    isSkipAuditAllowed: false,
    isSkippedAudit: false,
    leadAccount: '',
    leadAccountName: '',
    preparedDate: null,
    rolling12MonthsCredit: 0,
    state: '',
    territory: ''
});

export default Audit;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit.js